const ListItemSkeleton = () => {
	return (
		<li>
			<div className="check-title">
				<span className="skeleton" style={{ width: "4rem" }}></span>
				<span className="skeleton ml_10" style={{ width: "2rem" }}></span>
				{
					[... new Array(5)].map((item, index) => (
						<div key={index} className="check-list">
							<div>
								<div>
									<div className="img-box img-symbol" style={{ borderWidth: 0 }}>
										<div className="skeleton circle" style={{ width: "3.8rem", height: "3.8rem" }} />
									</div>
									<div className="skeleton ml_10" style={{ width: "12rem" }} />
								</div>
								<div>
									<div className="skeleton circle" style={{ width: "2.4rem", height: "2.4rem" }} />
								</div>
							</div>
						</div>
					))
				}
			</div>
		</li>
	)
}

export default ListItemSkeleton